/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Show_Vehicle_Paths_JourneysInputs */

const fr_settings_show_vehicle_paths_journeys = /** @type {(inputs: Settings_Show_Vehicle_Paths_JourneysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Courses uniquement`)
};

const en_settings_show_vehicle_paths_journeys = /** @type {(inputs: Settings_Show_Vehicle_Paths_JourneysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trips only`)
};

/**
* | output |
* | --- |
* | "Trips only" |
*
* @param {Settings_Show_Vehicle_Paths_JourneysInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_show_vehicle_paths_journeys = /** @type {((inputs?: Settings_Show_Vehicle_Paths_JourneysInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Show_Vehicle_Paths_JourneysInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_show_vehicle_paths_journeys(inputs)
	return en_settings_show_vehicle_paths_journeys(inputs)
});